import React, { useState } from "react";
import AppLayout from "@/Layouts/AppLayout";
import OrganizationLayout from "@/Layouts/OrganizationLayout";
import { Inertia } from "@inertiajs/inertia";
import { FormError } from "@/Components/FormError";
import { LabeledInput } from "@/Components/Form";
import { Formheader } from "@/Components";
import { SuccessMessage } from "@/Components/Messages";
import LayoutIcon from "@/Components/LayoutIcon";
import { User as UserIcon } from "@/Icons";
import TwoFactorSettings from "@/Pages/Account/partials/TwoFactorSettings";

export default function Profile({ user, errors, flash }) {
  const [dirty, setDirty] = useState(false);
  const [values, setValues] = useState({
    firstname: user?.data?.firstname || "",
    surname: user?.data?.surname || "",
    email: user?.data?.email || "",
    phone: user?.data?.phone || "",
    currentPassword: "",
    password: "",
    passwordConfirmation: "",
  });

  function handleUpdate(event) {
    setValues((prevValues) => {
      return { ...prevValues, [event.target.name]: event.target.value };
    });
    setDirty(true);
  }

  function isSaveDisabled() {
    return (
      !(values.firstname && values.surname && values.email && values.phone) ||
      !dirty
    );
  }

  function handleSave(e) {
    e.preventDefault();

    if (isSaveDisabled()) {
      return;
    }

    Inertia.put(
      `/your-account`,
      {
        firstname: values.firstname,
        surname: values.surname,
        email: values.email,
        phone: values.phone,
      },
      {
        onSuccess: () => setDirty(false),
      },
    );
  }

  function handlePasswordUpdate(e) {
    e.preventDefault();

    if (isSaveDisabled()) {
      return;
    }

    Inertia.put(
      `/your-account/update-password`,
      {
        password: values.password,
        password_confirmation: values.passwordConfirmation,
        current_password: values.currentPassword,
      },
      {
        onSuccess: () => {
          setDirty(false);
          setValues((prevValues) => ({
            ...prevValues,
            password: "",
            passwordConfirmation: "",
            currentPassword: "",
          }));
        },
      },
    );
  }

  function SettingsSaveButton() {
    let disabled = false;

    if (isSaveDisabled()) {
      disabled = true;
    }

    return (
      <button
        disabled={disabled}
        className="btn-blue inline-block max-w-fit self-end"
      >
        Save changes
      </button>
    );
  }

  return (
    <>
      {flash.status && <SuccessMessage>{flash.status}</SuccessMessage>}

      <div className="shadow-small mb-6 bg-gray-light p-4 pt-2 md:p-8 md:pt-4">
        <Formheader>Personal details</Formheader>

        <form onSubmit={handleSave}>
          <div className="flex flex-col flex-wrap justify-between md:flex-row">
            <div className="mb-4 w-full md:w-1/2 md:pr-3">
              <LabeledInput
                title="Firstname"
                placeholder="Enter firstname"
                name="firstname"
                required="required"
                value={values.firstname}
                onChange={handleUpdate}
              />
              <FormError error={errors.firstname} />
            </div>
            <div className="mb-4 w-full md:w-1/2 md:pl-3">
              <LabeledInput
                title="Surname"
                placeholder="Enter surname"
                name="surname"
                required="required"
                value={values.surname}
                onChange={handleUpdate}
              />
              <FormError error={errors.surname} />
            </div>
            <div className="mb-4 w-full md:w-1/2 md:pr-3">
              <LabeledInput
                title="E-mail"
                placeholder="Enter e-mail"
                name="email"
                required="required"
                value={values.email}
                onChange={handleUpdate}
              />
              <FormError error={errors.email} />
            </div>

            <div className="mb-4 w-full md:w-1/2 md:pl-3">
              <LabeledInput
                title="Phone number"
                placeholder="Enter phone number"
                name="phone"
                required="required"
                value={values.phone}
                onChange={handleUpdate}
              />
              <FormError error={errors.phone} />
            </div>

            <div className="flex w-full justify-end">
              {/*<a className="text-blue underline py-4 cursor-pointer">*/}
              {/*  Delete my account*/}
              {/*</a>*/}

              <SettingsSaveButton />
            </div>
          </div>
        </form>
      </div>

      <div className="shadow-small mb-6 bg-gray-light p-4 pt-2 md:p-8 md:pt-4">
        <Formheader>Change password</Formheader>
        <form onSubmit={handlePasswordUpdate}>
          <div className="flex flex-row flex-wrap justify-between">
            <div className="mb-4 w-full">
              <LabeledInput
                title="Current password"
                placeholder="Enter current password"
                name="currentPassword"
                type="password"
                required="required"
                autoComplete="none"
                value={values.currentPassword}
                onChange={handleUpdate}
              />
              <FormError error={errors.current_password} />
            </div>

            <div className="mb-4 w-full">
              <LabeledInput
                title="New password"
                placeholder="Enter new password"
                name="password"
                type="password"
                required="required"
                autoComplete="none"
                value={values.password}
                onChange={handleUpdate}
              />
              <FormError error={errors.password} />
            </div>

            <div className="mb-4 w-full">
              <LabeledInput
                title="Repeat new password"
                placeholder="Enter new password again"
                name="passwordConfirmation"
                type="password"
                required="required"
                autoComplete="none"
                value={values.passwordConfirmation}
                onChange={handleUpdate}
              />
              <FormError error={errors.repeat_password} />
            </div>

            <div className="flex w-full justify-end">
              <SettingsSaveButton />
            </div>
          </div>
        </form>
      </div>

      <TwoFactorSettings user={user.data} />
    </>
  );
}

Profile.layout = (page) => (
  <AppLayout title="Your account">
    <OrganizationLayout
      header="Your account"
      icon={
        <LayoutIcon>
          <UserIcon size={40} className="text-black" />
        </LayoutIcon>
      }
    >
      {page}
    </OrganizationLayout>
  </AppLayout>
);
